import { Component, OnInit } from '@angular/core';

import { DEPARTMENT_TYPE_PROFESSIONAL } from 'src/app/core/constants';

@Component({
    selector: 'app-professional-ranking-history',
    templateUrl: './professional-ranking-history.component.html',
    styleUrls: ['./professional-ranking-history.component.scss'],
})
export class ProfessionalRankingHistoryComponent implements OnInit {
    /**
     * Definição do tipo de departamento para sessão/depto Profissional
     */
    public departmentType: string = DEPARTMENT_TYPE_PROFESSIONAL;

    constructor() {}

    ngOnInit(): void {
        //console.log('departmentType= ' + this.departmentType);
    }
}
